import { render, staticRenderFns } from "./AppIntegrationsList.vue?vue&type=template&id=a4287488"
import script from "./AppIntegrationsList.vue?vue&type=script&lang=js"
export * from "./AppIntegrationsList.vue?vue&type=script&lang=js"
import style0 from "./AppIntegrationsList.vue?vue&type=style&index=0&id=a4287488&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports